import { useContext, useMemo } from 'react';
import {
  CATEGORY_CHILD_LOCATIONS,
} from '@lds/store-locator-js-sdk';
import { StoreLocatorContext } from '../components/StoreLocator';
import useBullseyeLocationDetails from './store-locator/useBullseyeLocationDetails';

interface Props {
  store: Record<string, any>;
  isKioskWelcome?: boolean;
}
const useTmsDeptHours = ({
  store,
  isKioskWelcome = false,
}: Props) => {
  const { options } = useContext(StoreLocatorContext);

  const searchOptions = useMemo(() => ({
    ...options,
    lclId: (store?.childLocationIds[CATEGORY_CHILD_LOCATIONS.TMS_DEPT])
    || store?.commonInfo.lclId,
    hoursOnly: true,
  }), [options, store]);

  const { location: tmsDept } = useBullseyeLocationDetails(searchOptions, isKioskWelcome);
  return tmsDept;
};

export default useTmsDeptHours;
